export const indexMonthSliderOptions = (instance, options) => {
    return {
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            hideOnClick: false,
            dynamicBullets: false,
        }
    }
}